import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const creatorHasReservedProductEndpoint = {
    authentication: authenticationTypes.authenticated,
    authenticationRole: userGroups.creator,
    endpointType: otherEndpointType,
    payloadSchema: {
        type: 'object',
        properties: {
            dropId: { type: 'string' },
        },
    },
    responseSchema: {
        type: 'boolean',
    },
};
